import React, { FC, memo, useContext, useRef } from 'react'

import { useMutation } from '@apollo/client'

import { AppContext, APPLY_DISCOUNT_CODE } from 'Const'
import useEvent from 'Hooks/useEvent'

import CodeBtn from './CodeBtn'

const ApplyDiscount: FC = () => {
  const { cart } = useContext(AppContext)
  const { appliedDiscountCodes } = cart
  const inputRef = useRef<HTMLInputElement>(null)

  const [applyDiscountCode] = useMutation(APPLY_DISCOUNT_CODE)

  const onButtonClick = useEvent(() => applyDiscountCode({ variables: { code: inputRef.current?.value } }))

  return (
    <div className="w-100">
      <div className="input-group">
        <input ref={inputRef} className="form-control" name="code" placeholder="Enter promo code" />

        <div className="input-group-append">
          <button className="btn btn-accent / py-1 / text-uppercase" type="button" onClick={onButtonClick}>
            Apply
          </button>
        </div>
      </div>

      {appliedDiscountCodes.length > 0 && (
        <div className="checkout-order__active-codes / mt-3">
          {appliedDiscountCodes.map(({ id, name, isValid }) => (
            <CodeBtn key={id} id={id} isValid={isValid} name={name} />
          ))}
        </div>
      )}
    </div>
  )
}

export default memo(ApplyDiscount)
